import { MessagePostType, MessageType } from "../types/Message";
import useSWR from "swr";
import { authFetcher, fetchWithAuth, MESSAGE_URL } from "./const.routes";
import { Result } from "../types/Result.ts";

export function useMessage(chatId: string, fallback: MessageType[]) {
  const { data, error, isLoading } = useSWR<MessageType[], Error>(
    `${MESSAGE_URL}${chatId}`,
    authFetcher,
  );

  return {
    messages: data ? data : fallback,
    isLoading,
    isError: error,
  };
}

export async function sendMessage(
  chatId: string,
  message: MessagePostType,
): Promise<Result<MessageType, string>> {
  const url = MESSAGE_URL + `${chatId}`;
  const response = await fetchWithAuth(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(message),
  });
  if (response.ok) {
    const message = (await response.json()) as MessageType;
    return { ok: true, value: message };
  } else {
    return { ok: false, error: response.statusText };
  }
}
